<template>
  <div class="Sys-warp">
    <el-breadcrumb class="bread_crumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="formData!=null">{{ getAuditTypeStr(formData.businessType) + '详情' }}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding-left: 85px;padding-right: 85px">
      <div class="title" v-if="formData!=null">{{ getAuditTypeStr(formData.businessType) + '详情' }}
      </div>
      <el-divider/>

      <div v-if="formData!=null"
           style="display: flex;margin-bottom: 30px;font-size: 20px;font-weight: bold;">
        <div style="color: #7d7d7d;width: 85px;margin-left: 20px;margin-right: 5px">审批状态</div>
        <div style="color:#3C3C3C;width: 85px" v-if="formData.status==1||formData.status==2">
          {{ formData.statusName }}
        </div>
        <div style="color: #118DEF;width: 80px" v-if="formData.status==3">
          {{ formData.statusName }}
        </div>
        <div style="color: orangered;width: 80px" v-if="formData.status==4">
          {{ formData.statusName }}
        </div>


        <!--下载审批文件-->
        <div v-if="judgeShowDownloadFile()" style="margin-left: 702px;margin-top: 2px">
          <el-link type="primary" @click="downloadInApplyFile" style="font-size: 16px">下载审批文件<i
              class="el-icon-download el-icon--right"/></el-link>
        </div>
        <!--重新发起申请-->
        <div v-if="formData.status==4" style="margin-left: 652px;margin-top: 2px">
          <el-link type="danger" @click="reInApply" style="font-size: 16px">修改资料重新发起审批<i
              class="el-icon-edit-outline el-icon--right"/></el-link>
        </div>
      </div>
      <div v-if="formData!=null&&formData.status==4"
           style="margin-left:110px;width:800px;color: orangered;font-size: 20px;margin-bottom: 20px;margin-top:-20px;font-weight: bold">
        原因：{{ formData.opinion }}
      </div>
      <el-form :model="formData" v-if="formData!=null" ref="ruleForm" label-width="110px" label-position="right"
               class="demo-ruleForm">
        <el-form-item label="审批编号"
                      v-if="businessType==constant.BUSINESS_TYPE_CHANGE||businessType==constant.BUSINESS_TYPE_IN">
          <el-input v-model="formData.displayApplyNo" maxlength="100" class="input" :disabled="true"/>
        </el-form-item>
        <el-form-item label="申请主体" prop="applyName">
          <el-input v-model="formData.applyName" maxlength="100" class="input" placeholder="请输入申请主体名称"
                    :disabled="true"/>
        </el-form-item>
        <div v-if="businessType==constant.BUSINESS_TYPE_COMPANY_LICENSE">
          <el-form-item label="营业执照" prop="companyLicenseFiles">
            <div class="img-container">
              <el-image
                  v-for="(item,index) in formData.companyLicenseFiles"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </div>
          </el-form-item>
        </div>
        <div v-if="businessType!=constant.BUSINESS_TYPE_COMPANY_LICENSE">

          <!-- 房屋使用证明申请才有的字段 -->
          <el-form-item label="租赁合同地址" prop="rentContractAddress"
                        v-if="businessType==constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.rentContractAddress" maxlength="100" class="input" :disabled="true"/>
          </el-form-item>

          <!-- 房屋使用证明申请才有的字段 -->
          <el-form-item label="申请《房屋使用证明》用途" prop="purposeStr"
                        v-if="businessType==constant.BUSINESS_TYPE_PROOF_OF_USE&&formData.purpose==1">
            <el-input v-model="formData.purposeStr" maxlength="100" class="input" :disabled="true"/>
          </el-form-item>

          <!-- 房屋使用证明申请才有的字段 -->
          <el-form-item label="申请《房屋使用证明》用途" prop="purposeDesc"
                        v-if="businessType==constant.BUSINESS_TYPE_PROOF_OF_USE&&formData.purpose==2">
            <el-input v-model="formData.purposeDesc" maxlength="100" class="input" :disabled="true"/>
          </el-form-item>

          <el-form-item label="入驻载体" prop="prjBaseInfoName" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.prjBaseInfoName" maxlength="100" class="input" :disabled="true"/>
          </el-form-item>

          <el-form-item label="入驻方式" prop="inType" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.inTypeName" maxlength="100" class="input" :disabled="true"/>
          </el-form-item>

          <el-form-item label="产业领域" prop="industrials" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-tag class="tag" v-for="(item,index) in formData.industrialList"> {{ item.industrialName }}</el-tag>
          </el-form-item>

          <el-form-item label="所属类型" prop="periodTypes" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-tag class="tag" v-for="(item,index) in formData.peridList"> {{ item.periodName }}</el-tag>
          </el-form-item>
          <el-form-item label="入驻门牌号" prop="roomNumber" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.roomNumber" maxlength="100" class="input" placeholder=""
                      :disabled="true"/>
          </el-form-item>

          <el-form-item label="法人代表" prop="legalPerson" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.legalPerson" maxlength="100" class="input" placeholder="请输入法人代表名称"
                      :disabled="true"/>
          </el-form-item>

          <el-form-item label="经营范围" prop="businessScope" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.businessScope" type="textarea" :rows="10" maxlength="800" resize="none"
                      class="input" placeholder="请输入经营范围" :disabled="true"/>
          </el-form-item>

          <el-form-item label="注册资本" prop="registeredCapital" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.registeredCapital" type="number"
                      maxlength="20" class="input" placeholder="请输入注册资本（单位：万元）" :disabled="true">
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>

          <el-form-item label="注册地址" prop="registeredAddress" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.registeredAddress" maxlength="220" class="input" placeholder="请输入注册地址"
                      :disabled="true"/>
          </el-form-item>

          <el-form-item label="载体面积" prop="squareMeasure" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.squareMeasure" type="number"
                      maxlength="20" class="input" placeholder="请输入载体面积（单位：平方米）" :disabled="true">
              <template slot="append">平方米</template>
            </el-input>
          </el-form-item>

          <el-form-item label="预计年产值" prop="expectYearValue" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.expectYearValue" type="number"
                      maxlength="20" class="input" placeholder="请输入预计年产值（单位：万元）" :disabled="true">
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>


          <el-form-item label="预计年税收" prop="expectYearTax" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.expectYearTax" type="number"
                      maxlength="20" class="input" placeholder="请输入预计年税收（单位：万元）" :disabled="true">
              <template slot="append">万元</template>
            </el-input>
            <div v-if="m2TaxRequirementInfo!=null&&!m2TaxRequirementInfo.isReach" style="color: orangered">未达到税收门槛</div>
          </el-form-item>

          <el-form-item label="员工人数" prop="numberOfEmployees" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.numberOfEmployees" :disabled="true" maxlength="9"   oninput="value=value.replace(/[^\d]/g,'')" class="input" placeholder="请输入员工数量"/>
          </el-form-item>

          <el-form-item label="联系人姓名" prop="contact" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.contact" maxlength="100" class="input" placeholder="请输入联系人姓名" :disabled="true"/>
          </el-form-item>

          <el-form-item label="联系人电话" prop="contactPhone" v-if="businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <el-input v-model="formData.contactPhone" maxlength="11" class="input" placeholder="请输入联系人手机号码"
                      :disabled="true"/>
          </el-form-item>
          <el-form-item label="核名通知书 /营业执照" prop="companyLicenseFiles" v-if="formData.companyLicenseFiles.length!=0">
            <div class="img-container">
              <el-image
                  v-for="(item,index) in formData.companyLicenseFiles"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </div>
          </el-form-item>

          <el-form-item :style="formData.companyLicenseFiles.length!=0?'margin-top: -20px':''" label="法人证件照"
                        prop="legalPersonFiles">
            <div class="img-container">
              <el-image
                  v-for="(item,index) in formData.legalPersonFiles"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </div>
          </el-form-item>

          <el-form-item style="margin-top: -20px" label="租赁合同" prop="rentContractFiles">
            <div class="img-container">
              <el-image
                  v-for="(item,index) in formData.rentContractFiles"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </div>
          </el-form-item>

          <el-form-item style="margin-top: -20px" label="全部股东证件照片（身份证或营业执照）" prop="shareholdersFiles"
                        v-if="formData.registeredCapital>=1000&&businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <div class="img-container">
              <el-image
                  v-for="(item,index) in formData.shareholdersFiles"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </div>
          </el-form-item>
          <el-form-item style="margin-top: -20px" label="其他证明文件" prop="otherFiles"
                        v-if="formData.otherFiles.length!=0||businessType!=constant.BUSINESS_TYPE_PROOF_OF_USE">
            <div class="img-container">
              <el-image
                  v-for="(item,index) in formData.otherFiles"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </div>
          </el-form-item>
        </div>


        <!--        <el-form-item>-->
        <!--          <div style="display: flex">-->
        <!--            <el-button style="flex-grow: 3" type="primary">提交</el-button>-->
        <!--            <el-button style="flex-grow: 1" @click="resetForm('ruleForm')">重置</el-button>-->
        <!--          </div>-->
        <!--        </el-form-item>-->
      </el-form>
    </div>


    <!--    预览图片的dialog-->
    <el-dialog :visible.sync="previewImgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <!--    阅读告知书的dialog-->
    <!--    <el-dialog-->
    <!--        title="入驻须知"-->
    <!--        :visible.sync="readNoticeVisible"-->
    <!--        width="1000px">-->

    <!--      <img width="100%" :src="noticePicUrl" alt="">-->
    <!--      <div style="display: flex;justify-content: center;margin-top: 20px;margin-bottom: 20px">-->
    <!--        <el-checkbox v-model="agreeNotice" style=" transform : scale(1.1)">我已阅读并同意以上内容</el-checkbox>-->
    <!--      </div>-->
    <!--      <div style="display: flex;justify-content: center">-->
    <!--        <sign ref="sign"></sign>-->
    <!--      </div>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--            <el-button @click="readNoticeVisible = false">取 消</el-button>-->
    <!--            <el-button type="primary" @click="">确 定</el-button>-->
    <!--          </span>-->
    <!--    </el-dialog>-->

  </div>
</template>

<script>

import {
  getEnumByClassName,
  getProjectOptions, inApply,
  uploadFileToBaiduCloud,
  getInApplyNoticePicUrl, getApplyInfo
} from "@/api/api";
import util, {base64toFile} from "@/utils/util"
import constant from "@/utils/constant"
import sign from "@/component/sign"

var validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入电话号码'))
  } else if (!util.checkMobile(value)) {
    callback(new Error('请输入正确的11位手机号码'))
  } else {
    callback()
  }
}

export default {
  name: 'InApplyDetail',
  components: {
    sign
  },
  data() {
    return {
      businessType: constant.BUSINESS_TYPE_IN,
      agreeNotice: false,
      constant: constant,
      previewImgDialogVisible: false,
      readNoticeVisible: false,
      dialogImageUrl: null,
      applyId: null,
      projectOptions: [],
      inTypeOptions: [],
      industrialOptions: [],
      periodTypeOptions: [],
      noticePicUrl: '',
      signFileName: null,
      m2TaxRequirementInfo: null,
      successData: {
        no: 2022,
        applyNo: 22
      },
      formData: null
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.applyId = this.$route.params.id
      getProjectOptions().then(res => {
        this.projectOptions = res.data
        getEnumByClassName('EnumInApplyType').then(res => {
          this.inTypeOptions = res.list;
          getEnumByClassName('EnumInApplyIndustrial').then(res => {
            this.industrialOptions = res.list;
            getEnumByClassName('EnumInApplyPeriodType').then(res => {
              this.periodTypeOptions = res.list;
              if (this.applyId == null) {
                this.$router.replace('home');
              } else {
                //applyId不为null，代表重新填写，获取之前的数据回填
                this.getApplyInfo();
              }
            })
          })
        })
      })
    },
    judgeShowDownloadFile() {
      if (this.formData.status == 3 && this.formData.businessType != constant.BUSINESS_TYPE_COMPANY_LICENSE) {
        return true
      }
      return false
    },
    getAuditTypeStr(businessType) {
      if (businessType == constant.BUSINESS_TYPE_CHANGE) {
        return '工商变更'
      }
      if (businessType == constant.BUSINESS_TYPE_IN) {
        return '入驻申请'
      }
      if (businessType == constant.BUSINESS_TYPE_COMPANY_LICENSE) {
        return '营业执照审批'
      }
      if (businessType == constant.BUSINESS_TYPE_PROOF_OF_USE) {
        return '房屋使用证明申请'
      }
    },
    getApplyInfo() {
      getApplyInfo(this.applyId).then(res => {
        if (res.code == 0) {
          this.formData = res.data.prjInApply;
          this.businessType = this.formData.businessType
          this.formData.displayApplyNo = this.formData.no.toString() + this.formData.applyNo.toString()

          this.formData.companyLicenseFiles = [] //营业执照，核名通知书
          this.formData.legalPersonFiles = [] //法人身份证照片
          this.formData.rentContractFiles = [] //租赁合同照片
          this.formData.shareholdersFiles = [] //股东证件
          this.formData.otherFiles = [] //其他证明文件
          this.formData.signNoticeFile = null;
          this.formData.applySuccessFile = null;

          for (var i = 0; i < this.formData.attachmentList.length; i++) {
            let attachment = this.formData.attachmentList[i]
            let value = {
              "name": attachment.ossFileName,
              "url": attachment.url
            }
            if (attachment.type == constant.CONST_COMPANY_LICENSE_FILE_TYPE) {
              this.formData.companyLicenseFiles.push(value);
            } else if (attachment.type == constant.CONST_LEGAL_PERSON_FILE_TYPE) {
              this.formData.legalPersonFiles.push(value);
            } else if (attachment.type == constant.CONST_RENT_CONTRACT_FILE_TYPE) {
              this.formData.rentContractFiles.push(value);
            } else if (attachment.type == constant.CONST_SHARE_HOLDERS_FILE_TYPE) {
              this.formData.shareholdersFiles.push(value);
            } else if (attachment.type == constant.COMPANY_APPLY_NOTICE_FILE_TYPE) {
              this.formData.signNoticeFile = value;
            } else if (attachment.type == constant.CONST_APPLY_SUCCESS_FILE_TYPE) {
              this.formData.applySuccessFile = value;
            } else if (attachment.type == constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE) {
              this.formData.otherFiles.push(value);
            }

          }

          //计算是否达到每平方米税收门槛
          //用年税收，单位万元，除以占地面积，因为服务端门槛是元为单位，所以这里先把单位转换为元
          let userPerM2TaxRequirement = this.formData.expectYearTax * 10000 / this.formData
              .squareMeasure;
          userPerM2TaxRequirement = userPerM2TaxRequirement.toFixed(2);
          console.log("userPerM2TaxRequirement=" + userPerM2TaxRequirement);
          let projectPerM2TaxRequirement = this.formData.projectPerM2TaxRequirement;
          console.log("projectPerM2TaxRequirement=" + projectPerM2TaxRequirement);

          let isReachTheThreshold;
          if (userPerM2TaxRequirement >= projectPerM2TaxRequirement) {
            isReachTheThreshold = true;
          } else {
            isReachTheThreshold = false;
          }
          this.m2TaxRequirementInfo = {
            isReach: isReachTheThreshold,
            userPerM2TaxRequirement: userPerM2TaxRequirement,
            projectPerM2TaxRequirement: projectPerM2TaxRequirement
          }


        } else {
          this.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.jumpToHome()
            }
          });
        }
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.previewImgDialogVisible = true;
    },
    jumpToHome() {
      this.$router.replace({
        name: 'home'
      });
    },
    downloadInApplyFile() {
      let url = this.formData.applySuccessFile.url;
      window.open(url)
    },
    reInApply() {
      let applyId = this.applyId
      if (this.businessType == constant.BUSINESS_TYPE_IN) {
        this.$router.push({
          name: 'InApplyWithInfo',
          params: {
            id: applyId,
            companyName: '0'
          }
        });
      } else if (this.businessType == constant.BUSINESS_TYPE_CHANGE) {
        this.$router.push({
          name: 'ChangeApply',
          params: {
            id: applyId,
            enterpriseId: '0',
            companyName: '0',
          }
        });
      } else if (this.businessType == constant.BUSINESS_TYPE_COMPANY_LICENSE) {
        this.$router.push({
          name: 'CompanyLicenseUploadApply',
          params: {
            enterpriseId: this.formData.enterpriseId
          }
        });
      } else if (this.businessType == constant.BUSINESS_TYPE_PROOF_OF_USE) {
        this.$router.push({
          name: 'ProofForUseApply',
          params: {
            enterpriseId: this.formData.enterpriseId,
            applyId: this.applyId,
          }
        });
      }


    }
  }
  ,
}
</script>
<style scoped>
.el-input.is-disabled /deep/ .el-input__inner {
  color: #606266;
}

.el-textarea.is-disabled /deep/ .el-textarea__inner {
  color: #606266;
}

.tag {
  margin-right: 10px;
  cursor: not-allowed;
}

.input {
  width: 100%
}

.img-container {
  display: flex;
  flex-wrap: wrap;
}

.img {
  width: 147px;
  height: 147px;
  margin-right: 20px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>
